import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { useLang } from "@/context/LanguageContext";
import { subscribeNewsletter } from "@/lib/api";

const Countdown = ({ target, lang }) => {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);
  const end = new Date(target).getTime();
  if (isNaN(end) || end <= now) return null;
  const diff = Math.floor((end - now) / 1000);
  const d = Math.floor(diff / 86400);
  const h = Math.floor((diff % 86400) / 3600);
  const m = Math.floor((diff % 3600) / 60);
  const s = diff % 60;
  const labels = lang === "ro" ? ["ZILE", "ORE", "MIN", "SEC"] : ["DAYS", "HRS", "MIN", "SEC"];
  const parts = [d, h, m, s];
  return (
    <div className="mt-10 flex items-start justify-center gap-4 sm:gap-8" data-testid="coming-soon-countdown">
      {parts.map((v, i) => (
        <div key={i} className="flex flex-col items-center">
          <span className="font-mono text-3xl font-bold tabular-nums sm:text-5xl">{String(v).padStart(2, "0")}</span>
          <span className="mt-1 font-mono text-[9px] uppercase tracking-[0.3em] text-muted-foreground">{labels[i]}</span>
        </div>
      ))}
    </div>
  );
};

const ComingSoon = ({ content }) => {
  const { lang, toggle } = useLang();
  const cs = content?.coming_soon || {};
  const heading = (lang === "ro" ? cs.ro : cs.en) || (lang === "ro" ? "ÎN CURÂND" : "COMING SOON");
  const sub = (lang === "ro" ? cs.sub_ro : cs.sub_en) || "";
  const [email, setEmail] = useState("");

  const subscribe = async (ev) => {
    ev.preventDefault();
    if (!email.includes("@")) return;
    try {
      await subscribeNewsletter(email);
      toast.success(lang === "ro" ? "Te-ai abonat!" : "Subscribed!");
      setEmail("");
    } catch { toast.error("Error"); }
  };

  return (
    <div className="flex min-h-screen flex-col bg-white text-foreground" data-testid="coming-soon-page">
      <div className="flex items-center justify-between border-b border-border px-4 py-4 sm:px-6">
        <img src="/logo.png" alt="LAINER" className="h-5 w-auto" />
        <button
          data-testid="coming-soon-lang"
          onClick={toggle}
          className="font-mono text-[11px] uppercase tracking-widest hover:opacity-60"
        >
          RO/EN
        </button>
      </div>

      <div className="flex flex-1 flex-col items-center justify-center px-4 py-16 text-center sm:px-6">
        <img src="/logo.png" alt="LAINER" className="h-7 w-auto" />
        <h1
          data-testid="coming-soon-heading"
          className="mt-6 text-4xl font-bold uppercase leading-none tracking-tight sm:text-5xl lg:text-6xl"
        >
          {heading}
        </h1>
        {sub ? (
          <p className="mt-6 max-w-md font-mono text-sm uppercase leading-relaxed tracking-widest text-muted-foreground">
            {sub}
          </p>
        ) : null}

        {cs.countdown ? <Countdown target={cs.countdown} lang={lang} /> : null}

        <form className="mt-10 flex w-full max-w-sm border border-border" onSubmit={subscribe}>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder={lang === "ro" ? "EMAILUL TĂU" : "YOUR EMAIL"}
            data-testid="coming-soon-newsletter-input"
            className="w-full bg-transparent px-3 py-3 font-mono text-[11px] uppercase tracking-widest placeholder:text-muted-foreground focus:outline-none"
          />
          <button
            type="submit"
            data-testid="coming-soon-newsletter-submit"
            className="bg-foreground px-5 font-mono text-[11px] text-white hover:opacity-85"
          >
            →
          </button>
        </form>

        <a
          href="https://www.instagram.com/lainer.co/"
          target="_blank"
          rel="noreferrer"
          data-testid="coming-soon-instagram"
          className="mt-8 font-mono text-[11px] uppercase tracking-widest hover:opacity-60"
        >
          Instagram
        </a>
      </div>

      <div className="flex items-center justify-center border-t border-border px-4 py-4">
        <Link
          to="/login"
          data-testid="coming-soon-login"
          className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground hover:text-foreground"
        >
          {lang === "ro" ? "Autentificare admin" : "Admin login"}
        </Link>
      </div>
    </div>
  );
};

export default ComingSoon;
